import React, {useState, useEffect, useRef} from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import ImageGallery from 'react-image-gallery';
import "../../node_modules/react-image-gallery/styles/css/image-gallery.css";
import CartPopup from '../Components/CartPopup';
import WishlistPopup from '../Components/WishlistPopup';
import Item from '../Components/Item/Item';
//import AuthContext from "../store/auth-context";
import NewsletterPopup from '../Components/NewsletterPopup';

function Home(props) {
  //const authCtx = useContext(AuthContext);
  const history = useHistory();
  const location = useLocation();
  const [AddToCart, setAddToCart] = useState(false);
  const [ToggleWishlist, setToggleWishlist] = useState(false); // per far apparire il dialog in caso l'utente sia non loggato
  const [NewsLetterOn, setNewsLetterOn] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [NetError, setNetError] = useState(null);
  const { isLoading, isError, data, error } = useQuery(["HomeData", props.token], () =>
      fetchHomeData(props.token)
  );
  const homeImages = [];

  const slideEl = useRef(null);

  async function fetchHomeData(token) {
    try {
      if (!props.token) return null;

      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token.access_token);
      myHeaders.append("Accept", "application/json");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        //mode: 'cors'
      };

      const response = await fetch(
        "https://ws.mediatoys.it/Home/Index",
        requestOptions
      );
      if (!response.ok) {
        if (response.status === 401) {
          // check error message???
          if (props.cfg.debug === true) 
            console.log("TOKEN UPDATE!");
          props.tokenUpdate();
        }
        throw new Error("Network error " + response.status);
      }
      const payload = await response.json();
      if (props.cfg.debug === true) {
        console.log("fetchHome() Ok");
        console.log(payload);
      }
      //setSlideImages(payload);
      return payload;
    } catch (error) {
      console.log(error.message);
      //setNetError(error.message);
      throw new Error(error.message);
    }
  }
 
  function addToCartHandler(productId, qty=1) {
    let params = [
      {name: "session", value: props.sessionKey},
      {name: "id_utente", value: props.userData? props.userData.id_e_user.toString() : "0"},
      {name: "id_e_products", value: productId.toString()},
      {name: "id_e_products_models", value: "0"},
      {name: "quantita_carrello", value: qty.toString()}
    ];
    props.wsCall("https://ws.mediatoys.it/carrello/add", IsLoading, setIsLoading, NetError, setNetError, params, (respData) => {
      props.cartUpd(respData.data);
      setAddToCart(true);
    });    
  }

  async function toggleWishListHandler(productId, flag) {
    //console.log(props.userData);
    if (props.userData && props.userData.id_e_user.length > 0) {
      //console.log("CLICCATO PREFERITI!");
      let params = [
        {name: "id_e_user", value: props.userData? props.userData.id_e_user.toString() : "0"},
        {name: "id_e_products", value: productId.toString()},
      ];
      props.wsCall("https://ws.mediatoys.it/cliente/add_del_prodotto_preferiti", IsLoading, setIsLoading, NetError, setNetError, params, (respData) => {
        //props.cartUpd(respData.data);
        //setAddToCart(true);
        props.setWishlist(respData);
        //console.log(respData);
      })
    } else {
      setToggleWishlist(true);  
    }
  }

  
  function closeCartDialog() {
    setAddToCart(false);
  }
  function closeWishlistDialog() {
    setToggleWishlist(false);
  }
  function closeNewsletterDialog() {
    setNewsLetterOn(false);
  }

/*
  function manageCategoryBanners() {
    let banner = data.find((el) => el.type === "banner");
    if (!banner) 
        return null;
    return (
      <>
        {banner.data.map((el, i) => (
          <Link to={el.cta} key={"ct_"+i}>
            <div className="torre_linea">
              <img src={el.img} alt={el.alt} />
            </div>
          </Link>
        ))}
      </>
    );
  }
*/
  function manageCategoryBanners() {
    let banner = data.find((el) => el.type === "banner");
    if (!banner) 
        return null;
    return (
      <>
        {banner.data.map((el, i) => {
          if (el.type === "link")
            // category url
            return (
              <Link to={el.cta} key={"ct_" + i}>
                <div className="torre_linea">
                  <img src={el.img} alt={el.alt} />
                </div>
              </Link>
            );
          // video
          else 
            return <></>;
        })}
      </>
    );
  }

  function itemClickHandler(ev) {
    //console.log("Clicked");
    let curLoc = history.location;
    curLoc.state = { itemScrollTop: document.documentElement.scrollTop };
    history.replace(curLoc);
    //console.log("document.scrollTop = " + document.documentElement.scrollTop);
  }  
/*
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
*/
  useEffect(() => {
    //console.log("Scroll Restoration manager");
    if (history.location.state && history.location.state.itemScrollTop >= 0) {
      //console.log("Scroll Restoration to " + history.location.state.itemScrollTop);
      window.scrollTo(0, history.location.state.itemScrollTop);
      let curLoc = history.location;
      curLoc.state = { itemScrollTop: -1 };
      history.replace(curLoc);
    } else {
        if  ((!history.location.state) || (history.location.state && history.location.state.itemScrollTop !== -1)) {
          //console.log("SCROLL DUE");
          window.scrollTo(0, 0);
        }
    }
    //console.log(history.location);
  }, [location.key]);
//}, [history]);
//}, [location.pathname]);
//}, [ActiveFilters]);  // perfetto per i filtri, ma annulla lo scroll restoration perchè chiamato successivamente a meno che non si usi la if sopra


  function manageItemList() {
    let products = data.find((el) => el.type === "products");
    if (!products || !products.data || products.data.length === 0) 
      return null;

    return (
      <div className="contenitore_consigliati">
        <div className="titolo_consigliati">
          <h3>{products.lable}</h3>
        </div>
        <div className="torri_consigliati">
          {products.data.map((item, i) => (
            <Item
              key={"itc_" + item.id_e_products}
              item={item}
              urlImg={props.cfg.urlItemImg}
              click={addToCartHandler}
              toggle={toggleWishListHandler}
              navClick={itemClickHandler}
              wishlist={props.wishlist}
              convert={props.cfg.convert}
              catalogSlug={props.cfg.catalogSlug}        
            />
          ))}
        </div>
      </div>
    );
  }

  function slideClickHandler() {
    let idx = slideEl.current.getCurrentIndex();
    if (data && idx >= 0) {
      let slider = data.find((el) => el.type === "slider");
      if (slider.data.length > idx) {
        //let cta = slider[idx]
        history.push(slider.data[idx].cta);
      }
    }
  }

  if (data) {
    let slider = data.find((el) => el.type === "slider");
    if (slider) {
      slider.data.forEach((el) => {
        homeImages.push({
          original: el.img,
          thumbnail: el.img,
          originalAlt: el.alt,
          thumbnailAlt: el.alt,
        });
      });
    }
  }

  //console.log(props);
  if (!data || isLoading === true) {
    return (
      <>
        <div className="spinner">
          <img src="/images/waiting.gif" alt="loading..." />
        </div>

        {isError && error !== null ? <p>{error.message}</p> : null}
      </>
    );
  } else 
  return (
    <>
      {AddToCart === true ? (
        <CartPopup
          titletext="Congratulazioni!"
          text="Articolo aggiunto al carrello"
          closeHandler={closeCartDialog}
        />
      ) : null}
      {ToggleWishlist === true ? (
        <WishlistPopup
          titletext=""
          text=""
          closeHandler={closeWishlistDialog}
        />
      ) : null}
      {NewsLetterOn === true ? (
        <NewsletterPopup
          token={props.token}
          sessionKey={props.sessionKey}
          tokenUpdate={props.tokenUpdate}
          wsCall={props.wsCall}
          closeHandler={closeNewsletterDialog}
          privacyUrl={props.cfg.iubendaPrivacyUrl}
        />
      ) : null}
      <div className="contenitore_01">
        <div className="contenuto_01">
          <div>
            <ImageGallery
              ref={slideEl}
              items={homeImages}
              showThumbnails={false}
              showFullscreenButton={false}
              onClick={slideClickHandler}
            />
          </div>
          <div className="contenitore_linee">{manageCategoryBanners()}</div>

          <div className="titolo_home">
            <h1>
              Iscriviti alla <span onClick={(e) => setNewsLetterOn(true)}>NEWSLETTER</span> di Bburago e rimani aggiornato sulle nostre novità!
            </h1>
          </div>
        </div>

        {manageItemList()}

        <div className="clear"></div>
      </div>
    </>
  );
}

export default Home;